// import { Redirect } from "react-router-dom"
import { all, fork, put, takeEvery } from "redux-saga/effects"
import { getErrors, setCheckoutCartSuccess } from "../reducers/ProcessToCheckoutReducer"

// Watchers
function* processToCheckoutSaga() {
	yield takeEvery("process_to_checkout/setCheckoutCart", getAllProcessToCheckout)
}

// Sagas
function* getAllProcessToCheckout(action) {
	// console.log(action)
    try {
        yield put(setCheckoutCartSuccess(action.payload))
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(processToCheckoutSaga)])
}
